import { Alert, Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { ComponentType } from 'react';
import { useSampleSet } from '../../../../../../contexts/SampleSetContext';
import {
  type AnalysisResultType,
  hasAnalysisViews,
} from '@/lib/jobs/analysisViews';
import HydraDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/hydra/HydraDifferentialAnalysisTab';
import IdDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/id/IdDifferentialAnalysisTab';
import IdParquetDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/id/IdParquetDifferentialAnalysisTab';
import MwmineFeaturesDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/mwmineFeatures/MwmineFeaturesDifferentialAnalysisTab';
import PeptidesDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/peptides/PeptidesDifferentialAnalysisTab';
import QuantDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/quant/QuantDifferentialAnalysisTab';

const DIFFERENTIAL_ANALYSIS_TABS: Record<AnalysisResultType, ComponentType> = {
  QUANT: QuantDifferentialAnalysisTab,
  ID: IdDifferentialAnalysisTab,
  ID_PARQUET: IdParquetDifferentialAnalysisTab,
  HYDRA: HydraDifferentialAnalysisTab,
  PEPTIDES: PeptidesDifferentialAnalysisTab,
  MWMINE_FEATURES: MwmineFeaturesDifferentialAnalysisTab,
};

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/differential-analysis'
)({
  staticData: { ddViewName: 'experiments-differential-analysis-tab' },
  component: DifferentialAnalysisRouteComponent,
});

function DifferentialAnalysisRouteComponent() {
  const { selectedJob, selectedJobId, jobs } = useSampleSet();

  const showAlert = !selectedJobId && jobs.length > 0;

  // The layout sends the user to Samples when the run has no analysis views.
  const resultType = selectedJob?.result_type;
  const DifferentialAnalysisTab = hasAnalysisViews(resultType)
    ? DIFFERENTIAL_ANALYSIS_TABS[resultType]
    : null;

  return (
    <>
      {showAlert && (
        <Box sx={{ mx: 2, mt: 1 }}>
          <Alert severity="info" sx={{ mb: 1 }}>
            Please select an inference run to view differential analysis results
          </Alert>
        </Box>
      )}
      {DifferentialAnalysisTab && <DifferentialAnalysisTab />}
    </>
  );
}
